import * as t from "io-ts"

export const TReasonCode = t.interface({
  code: t.string,
  description: t.string
})

export const TReasonCodes = t.array(TReasonCode)

export type ReasonCode = t.TypeOf<typeof TReasonCode>
export type ReasonCodes = t.TypeOf<typeof TReasonCodes>
